import { useState, useCallback } from 'react';
import AuthContext from "./context/AuthContext";
import allowedEmails from "./login/allowedEmails";
import { NotificationManager } from "react-notifications";

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState(null);
    const [speakers, setSpeakers] = useState([]);

    const updateSpeakers = useCallback((speakersList) => {
        setSpeakers(speakersList);
    }, []);

    const login = ({ email, conferenceName }) => {
        // Проверяем, является ли email допустимым для данной конференции
        const isAllowedEmail = allowedEmails.some(entry => entry.email === email && entry.eventName === conferenceName);

        if (isAllowedEmail) {
            setAuth({ user: email });
        } else {
            NotificationManager.error('You don\'t have access to the post material\n', 'Unfortunately', 5000);
        }
    };

    return (
        <AuthContext.Provider value={{ auth, login, updateSpeakers }}>
            {children}
        </AuthContext.Provider>
    );
};